var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login_content"},[_c('h4',[_vm._v("微信登录")]),_c('img',{attrs:{"src":_vm.codeUrl,"alt":""}}),_c('p',[_vm._v("请使用微信扫描二维码登录")])])])}
var staticRenderFns = []

export { render, staticRenderFns }